var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.032 8.072h-9.61v15.735h9.61V8.072z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.39 16.004a9.997 9.997 0 013.805-7.868c-4.32-3.418-10.64-2.644-14.059 1.677-3.418 4.32-2.644 10.64 1.677 14.059 3.611 2.837 8.706 2.837 12.382 0-2.386-2-3.805-4.901-3.805-7.868z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.415 22.195v-.322h.129v-.065h-.323v.065h.13l.064.322zm.645 0v-.387h-.13l-.128.258-.13-.258h-.128v.387h.064v-.322l.13.258h.064l.129-.258v.322h.129zM40.382 16.004A9.963 9.963 0 0130.386 26c-2.257 0-4.45-.774-6.191-2.128a10.03 10.03 0 001.677-14.06 10.314 10.314 0 00-1.677-1.676c4.32-3.418 10.64-2.644 14.059 1.677 1.419 1.741 2.128 3.934 2.128 6.191z",
    fill: "#F79E1B"
  })));
}
export default SvgMastercard;